import { supabase } from '@/config/supabase'
import type { Integracao, UUID } from '@/types/database'

export const integracaoService = {
    async list() {
        const { data, error } = await supabase
            .schema('veicular_system')
            .from('veic_integracoes')
            .select('*')
            .order('nome')

        if (error) throw error
        return (data || []) as unknown as Integracao[]
    },

    async get(id: UUID) {
        const { data, error } = await supabase
            .schema('veicular_system')
            .from('veic_integracoes')
            .select('*')
            .eq('id', id)
            .single()

        if (error) throw error
        return data as unknown as Integracao
    },

    async create(input: Partial<Integracao>) {
        const { data, error } = await supabase
            .schema('veicular_system')
            .from('veic_integracoes')
            // @ts-ignore
            .insert(input as any)
            .select()
            .single()

        if (error) throw error
        return data as unknown as Integracao
    },

    async update(id: UUID, input: Partial<Integracao>) {
        const { data, error } = await supabase
            .schema('veicular_system')
            .from('veic_integracoes')
            // @ts-ignore
            .update(input as any)
            .eq('id', id)
            .select()
            .single()

        if (error) throw error
        return data as unknown as Integracao
    },

    async remove(id: UUID) {
        const { error } = await supabase
            .schema('veicular_system')
            .from('veic_integracoes')
            .delete()
            .eq('id', id)

        if (error) throw error
    },

    async test(_id: UUID, payload: Record<string, any>) {
        // Simulação de teste - futuramente chamará Edge Function
        await new Promise(resolve => setTimeout(resolve, 1500))

        // Retorno simulado de sucesso
        return {
            status: 200,
            data: { success: true, message: 'Teste realizado com sucesso', sent_payload: payload },
            duration_ms: 250
        }
    }
}
